export const SET_PLAY_SONG = 'SET_PLAY_SONG'
export const SET_ALARM_SONG = 'SET_ALARM_SONG'
export const SET_SEND_NOTIFICATIONS = 'SET_SEND_NOTIFICATIONS'
export const SET_POMODORO_LENGTH = 'SET_POMODORO_LENGTH'
export const SET_BREAK_LENGTH = 'SET_BREAK_LENGTH '
export const SET_SHORT_BREAK_LENGTH = 'SET_SHORT_BREAK_LENGTH'
export const SET_LONG_BREAK_LENGTH = 'SET_LONG_BREAK_LENGTH'
export const SET_LUNCH_BREAK_LENGTH = 'SET_LUNCH_BREAK_LENGTH'
export const SET_DISPLAY_BREAK_MENU = 'SET_DISPLAY_BREAK_MENU'
export const SET_AUTOMATIC_BREAK = 'SET_AUTOMATIC_BREAK'
export const SET_AUTOMATIC_POMODORO = 'SET_AUTOMATIC_POMODORO'
export const SET_POMODORO_COUNT = 'SET_POMODORO_COUNT'
export const SET_POMODORO_DAILY_TARGET = 'SET_POMODORO_DAILY_TARGET'
export const SET_POMODORO_WEEKLY_TARGET = 'SET_POMODORO_WEEKLY_TARGET'
export const SET_DISPLAY_DOC_TITLE_TIMER = 'SET_DISPLAY_DOC_TITLE_TIMER'
export const SET_OPEN_SETTINGS = 'SET_OPEN_SETTINGS'
export const SET_OPEN_LOGS = 'SET_OPEN_LOGS'
export const SET_TIMER_TYPE = 'SET_TIMER_TYPE'
export const SET_CURRENT_SESSION = 'SET_CURRENT_SESSION'
export const SET_END_TIME_AND_SAVE = 'SET_END_TIME_AND_SAVE'
